define.alias("shared/components/shared/post/secondary/caption-writer/list-item", "settings/components/shared/post/secondary/caption-writer/list-item");